import ApiClient from "../apiClient";

export interface ConsulBrowserSession {
  id: string;
  liveUrl: string;
  createdAt?: string;
}

export interface ConsulBrowserStats {
  active: boolean;
  liveUrl: string | null;
  sessionId: string | null;
  dayCount: number;
  dayCap: number;
  idleTtlMs: number;
}

export interface ConsulBrowserService {
  getActive(): Promise<{
    session: ConsulBrowserSession | null;
    stats: ConsulBrowserStats;
  }>;
  create(): Promise<{
    session: ConsulBrowserSession;
    stats: ConsulBrowserStats;
  }>;
  close(): Promise<boolean>;
  extract(): Promise<boolean>;
}

export function createConsulBrowserService(
  client: ApiClient,
): ConsulBrowserService {
  return {
    async getActive() {
      return client.get<{
        session: ConsulBrowserSession | null;
        stats: ConsulBrowserStats;
      }>("/api/browserbase/sessions/active");
    },

    async create() {
      return client.post<{
        session: ConsulBrowserSession;
        stats: ConsulBrowserStats;
      }>("/api/browserbase/sessions");
    },

    async close() {
      const json = await client.delete<{ ok: boolean }>(
        "/api/browserbase/sessions/active",
      );
      return Boolean(json.ok);
    },

    async extract() {
      const json = await client.post<{ ok: boolean }>(
        "/api/browserbase/sessions/active/extract",
      );
      return Boolean(json.ok);
    },
  };
}
